export const isCoordinador = (user) => {
  return ["admin", "coordinador"].includes(user?.permiso);
};

export const notCliente = (user) => {
  return !["invitado", "cliente"].includes(user.permiso);
};

// Roles that can edit, soft delete and restore partidas and destajos of an obra.
export const canEditPartidas = (permiso) => {
  return ["admin", "coordinador", "supervisor", "obras"].includes(permiso);
};
